import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=7a394b7f&scoped=true"
import script from "./TextList.vue?vue&type=script&lang=js"
export * from "./TextList.vue?vue&type=script&lang=js"
import style0 from "./TextList.vue?vue&type=style&index=0&id=7a394b7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a394b7f",
  null
  
)

export default component.exports